import { useState } from 'preact/hooks';

export const WeightTabs = ({ weights, activeIdx, onSelect, onAdd, onRemove }) => {
  const [adding, setAdding] = useState(false);
  const [newLpi, setNewLpi] = useState('');

  const submit = () => {
    if (!newLpi.trim()) return;
    onAdd({ lpi: newLpi.trim(), density: [], steps: [] });
    setNewLpi(''); setAdding(false);
  };

  return (
    <div class="flex flex-wrap items-center gap-1.5">
      {weights.map((w, i) => (
        <button
          key={i}
          type="button"
          onClick={() => onSelect(i)}
          class={`rounded-full border px-3 py-1 font-mono text-[11px] ${
            i === activeIdx
              ? 'border-brand bg-brand/[0.12] text-brand'
              : 'border-border-strong bg-bg-card text-text-tertiary hover:text-text-primary'
          }`}
        >
          {w.lpi || '—'}
          {i === activeIdx && weights.length > 1 && (
            <span
              role="button"
              tabIndex={0}
              onClick={(e) => { e.stopPropagation(); if (window.confirm(`Remove ${w.lpi}?`)) onRemove(i); }}
              class="ml-1.5 text-text-muted hover:text-ink-magenta"
            >×</span>
          )}
        </button>
      ))}
      {adding ? (
        <input
          class="w-20 rounded-full border border-border-strong bg-bg-card px-3 py-1 font-mono text-[11px]"
          value={newLpi}
          onInput={(e) => setNewLpi(e.currentTarget.value)}
          placeholder="150#"
          autoFocus
          onKeyDown={(e) => { if (e.key === 'Enter') submit(); if (e.key === 'Escape') setAdding(false); }}
          onBlur={() => { if (newLpi.trim()) submit(); else setAdding(false); }}
        />
      ) : (
        <button onClick={() => setAdding(true)} class="rounded-full border border-dashed border-border-tertiary px-3 py-1 text-[11px] text-text-tertiary hover:text-text-primary">+ LPI</button>
      )}
    </div>
  );
};
